module.exports = wpApiSettings;